export class CurrencyModel {
  public id: number = null;
  public name: string = null;
  public iso: string = null;
  public symbol: string = null;
  public minimumAmountForTransaction: number = null;
  public isInbound: boolean = false;
  public ordinal: number = 0;
  public transactionFee: number;

  static fromJson(json): CurrencyModel {
    if (!json) {
      return null;
    }
    const model = new CurrencyModel();
    model.id = json.id;
    model.name = json.name;
    model.iso = json.iso;
    model.symbol = json.symbol;
    model.minimumAmountForTransaction = json.minimumAmountForTransaction;
    model.isInbound = json.isInbound;
    model.ordinal = json.ordinal;
    return model;
  }
}
